<template>
  <div class="imgList">
    <div class="et-tabhead">
        <span class="et-back" @click="detail">
          <i class="icon-back"></i>
          详情
        </span>
      <div class="et-tabtn">
        <div class="et-tabtn" id="but-tabtn">
           <span class="btn-et-form" style="padding-right: 10px;border-right: none">
               共<span style="border-right: none">{{current}}/{{total-currentName}}</span>个作品
           </span>
        </div>
      </div>
    </div>
    <div class="imgConen">
      <div class="Exhibition">
        <div class="swiper-container swiper-pic">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item,key) in total">
                <img class="swiper-img" style="min-height: 100px"  v-if="imgList[key]" :src="imgList[key].file.image_url" alt=""/>
            <!--    <img class="swiper-img" style="min-height: 100px" v-if="imgList[key]"  :src="imgList[key].thumb_path" alt=""/>
            -->  <h3 class="img-title" v-if="imgList[key]">{{imgList[key].file.title}}</h3>
              <div class="img-user" v-if="imgList[key] && imgList[key].user.nick_name">
                <img style="min-height: 0" :src="imgList[key].user.face_url" alt=""/>{{imgList[key].user.nick_name}}
              </div>
             <!--  <div class="img-user" v-if="imgList[key] && imgList[key].nickname">
                <img style="min-height: 0" :src="imgList[key].user.face_url" alt=""/>{{imgList[key].nickname}}
              </div> -->
              <p class="img-detail" v-if="imgList[key]">{{imgList[key].file.description}}</p>
            </div>
          </div>
        </div>
     <!--   <ul style="margin: 0;padding: 0">
          <li v-for="(item,key) in imgList" >{{key}} <img src="../../../static/dist/image/icon-face.png" alt=""/></li>
        </ul>-->
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        data ()
    {
        return {
          id: '',
          bestWorks: null,
          imgList: [],
          total: '',
          page: 1,
          nickname: '',
          title: '',
          description: '',
          init: 0,
          current: 1,
          currentName: ''
        }
    }
    ,
    methods: {
        //操作按钮事件
      detail(){
        this.$router.push({name: 'Detail', params: {id: this.id}})
      }
    }
    ,
    created: function () {

      this.id = this.$route.params.id;
      this.init = this.$route.params.init || 0;
      var that = this;
      $('.wrap').css('background','#e8e8e8');
      if(this.init > 0){
        var currentPage =  Math.ceil(this.init / 10);
        that.bestWorks = {
          type: 2,
          activity_id: that.id,
          page: currentPage,
          pagesize: 10
        };
        that.page = currentPage;
        that.currentName =  (currentPage-1)*10
      }else{
        that.bestWorks = {
          type: 2,
          activity_id: that.id,
          page: that.page,
          pagesize: 10,
          version: 2
        };
      }

      that.$http.get(API.GetActivitieById, {params: {id: that.id}})
        .then(function (res) {
          //微信分享
          let metas = $('head').children('meta');
          var  desc = '',
            img = res.data.playbill.playbill;
          if(res.data.description){
            desc = res.data.description
          }else{
            desc = metas[1].content;
          }
          var dataName = {
            title: res.data.title,  //分享标题
            desc: desc,//分享简介(内容)
            imgAddress: img,//分享图片地址
            Retain: '',//保留
            url:  window.location.href //点击分享结果跳转的地址(默认情况为分享页面当前地址)
          };
          //console.log(dataName)
          that.weixinShare(dataName)
        });
      that.$watch(function(){
        //console.log(that.bestWorks)
        that.$http.get(API.FileRelatedVideo, {params: that.bestWorks})
          .then(function (res) {
         //  console.log(res)
          var _data = res.data;
          if(res.code == 0){
            that.total = res.total;
            that.imgList = that.imgList.concat(_data);

            // for(var i=0;i<_data.length;i++){
            //     that.imgList.push(_data[i])
            // }
          }
          that.$nextTick(function(){


            if(that.init == 1){
              if(that.imgList[that.init-1].height > that.imgList[that.init-1].width){
                var Pw =  that.imgList[that.init-1].width /$('.Exhibition').width();
                var H = that.imgList[that.init-1].height / Pw;
                $('.imgList .Exhibition').find('.swiper-img').eq(that.init-1).css('height',H);
              }else{
                $('.imgList .Exhibition').find('.swiper-img').eq(that.init-1).css('height','auto');
              }
            }
            var swiperPic = new Swiper('.swiper-pic', {
              initialSlide: that.init-1,
              onSlideChangeEnd:function(swiper){
                that.current = swiper.activeIndex + 1;
                var index = swiper.activeIndex;
                var len = that.imgList.length - 1;
                if(that.imgList[index].height > that.imgList[index].width){
                  var Pw =  that.imgList[index].width /$('.Exhibition').width();
                  var H = that.imgList[index].height / Pw;
                  $('.imgList .Exhibition').find('.swiper-img').eq(index).css('height',H);
                }else{
                  $('.imgList .Exhibition').find('.swiper-img').eq(index).css('height','auto');
                }
                var dome = $('.imgList .Exhibition').find('.swiper-img').eq(index+1).attr('src');
                that.init = index+1;
                if(that.total != len +1 && index+1 >= len){
                    that.bestWorks = {
                      type: 2,
                      activity_id: that.id,
                      page: ++that.page,
                      pagesize: 10
                    }
                }
              }
            });
          })
        })
      })

    },
    mounted: function () {
        //操作DOM
  /*    $('ul').css('transform','translate3d(0px,0,0)');
      var t = 'translate3d(50px, 0px, 0px)';
      var m = 0;*/

    }

    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/list/imgList.vue